import React from 'react';
import utils from '../../utils';
import fetch from '../fetch';
import {Tag} from 'antd';
import moment from 'moment';

const DataGrid = {
    selections: [],
    refresh: function() {

    }
}

const setRefresh = (callback) => {
    DataGrid.refresh = callback
}


const onSelect = (ids) => {
    DataGrid.selections = ids
}

const getSelection =() => {
    return DataGrid.selections;
}

const columnsArray = [
    {type: 'selection'},
    {key:'$index', label: '序号'},
    {
        key: 'orgName', width: 100,
        label: '所属部门'
    },
    {
        key: 'objectCode', width: 100,
        label: '对象编号'
    },
    {
        key: 'objectName', width: 100,
        label: '对象名称'
    },
    {
        key: 'targetName', width: 100,
        label: '指标名称',
    },
    {
        key: 'selfAssessScore', width: 100,
        label: '自评分数',
    },
    {
        key: 'earlyWarningStatu', width: 90,
        label: '预警状态',render:(value) =>{
            if(value === '预警状态'){
            return  <span style={{textAlign:"center",display:"block"}}><Tag color="#f5222d" >{value}</Tag></span>
            }else{
                return  <span style={{textAlign:"center",display:"block"}}><Tag color="#108ee9">{value}</Tag></span>
            }
        }
    },
    {
        key: 'earlyWarningDesc', width: 120,
        label: '预警描述'
    },
    {
        key: 'avgScore', width: 120,
        label: '平均分'
    },
    {
        key: 'compareAvgScore', width: 120,
        label: '与平均分相较',render:(value) =>{
            if(value === '低于平均分'){
            return  <span style={{textAlign:"center",display:"block"}}><Tag color="#f5222d" >{value}</Tag></span>
            }else if(value === '高于平均分'){
                return  <span style={{textAlign:"center",display:"block"}}><Tag color="#52c41a">{value}</Tag></span>
            }else {
                return  <span style={{textAlign:"center",display:"block"}}><Tag color="#1890ff">{value}</Tag></span>
            }
        }
    },
    {
        key: 'termName', width: 120,
        label: '学期'
    },
    {key:'createTime', label: '创建时间', width: 120, render: (value)=> value ? moment(new Date(value)).format('YYYY/MM/DD') : ""},
]

const headers = utils.columns([
    {type: 'selection'},
    {key:'$index', label: '序号'},
    {
        key: 'orgName', width: 100,
        label: '所属部门'
    },
    {
        key: 'objectCode', width: 100,
        label: '对象编号'
    },
    {
        key: 'objectName', width: 100,
        label: '对象名称'
    },
    {
        key: 'targetName', width: 100,
        label: '指标名称',
    },
    {
        key: 'selfAssessScore', width: 100,
        label: '自评分数',
    },
    {
        key: 'earlyWarningStatu', width: 90,
        label: '预警状态',render:(value) =>{
            if(value === '预警状态'){
            return  <span style={{textAlign:"center",display:"block"}}><Tag color="#f5222d" >{value}</Tag></span>
            }else{
                return  <span style={{textAlign:"center",display:"block"}}><Tag color="#108ee9">{value}</Tag></span>
            }
        }
    },
    {
        key: 'earlyWarningDesc', width: 120,
        label: '预警描述'
    },
    {
        key: 'avgScore', width: 120,
        label: '平均分'
    },
    {
        key: 'compareAvgScore', width: 120,
        label: '与平均分相较',render:(value) =>{
            if(value === '低于平均分'){
            return  <span style={{textAlign:"center",display:"block"}}><Tag color="#f5222d" >{value}</Tag></span>
            }else if(value === '高于平均分'){
                return  <span style={{textAlign:"center",display:"block"}}><Tag color="#52c41a">{value}</Tag></span>
            }else {
                return  <span style={{textAlign:"center",display:"block"}}><Tag color="#1890ff">{value}</Tag></span>
            }
        }
    },
    {
        key: 'termName', width: 120,
        label: '学期'
    },
    {key:'createTime', label: '创建时间', width: 120, render: (value)=> value ? moment(new Date(value)).format('YYYY/MM/DD') : ""},
])

const querySearch = (keywords = {pageNum: 1, pageSize: 100}) => {
    var params = [];
    var newKeyword = {};
    const session = JSON.parse(sessionStorage.session || '{"account": {}}')
    const account = session.account;

    const defaultsParams = {
        bgTermId: account.termId,
        endTermId: account.termId
    };

    for(var i in keywords) {
        if(i === 'pageSize'){
            params.push(`pageSize=${keywords[i]}`);
        } else if(i === 'pageNum'){
            params.push(`pageNum=${keywords[i]}`);
        } else if(i === 'sort'){
            params.push(`sort=${keywords[i]}`);
        } else {
            newKeyword[i] = keywords[i];
        }
    }
    
    return fetch.post('zgcp/earlywarning/selfassess/query?'+ params.join('&'), Object.assign({
        type: "view"
    }, defaultsParams, newKeyword))
    .then(response => {
        let extParams = response.payload.meta.extParams;
        let newArray = [] 
        if(extParams) {
            for(let i = 0; i < columnsArray.length; i++) {
                if(columnsArray[i].key != 'className'&& columnsArray[i].key != 'objectCode'){
                    newArray.push(columnsArray[i])
                }
                if((extParams.objectType == 4 || extParams.objectType == 1 ) && columnsArray[i].key == 'objectCode'){
                    newArray.push(columnsArray[i])
                }
                if(extParams.objectType == 4 && columnsArray[i].key == 'className'){
                    newArray.push(columnsArray[i])
                }
                if(i === 9) {
                    if(extParams.options.length > 0){
                        extParams.options.forEach(o => {
                            var key = o.name;
                            if(key.indexOf("FILEVO-") != -1){
                                newArray.push({
                                    key: o.name,
                                    label: o.value, 
                                    width: 120,
                                    render: (files) => {
                                        if(files && files.length > 0) {
                                            return (
                                                <ol className="upper-alpha">
                                                    {
                                                        files.map((file) => (
                                                            <li><a href={window.base + 'zgcp/enter/file/download?id=' + file.id} target="_blank">{ file.fileName }</a></li>
                                                        ))
                                                    }
                                                </ol>
                                            )
                                        }
                                        return "无";
                                    }
                                })
                            }else{
                                newArray.push({
                                    key: o.name,
                                    label: o.value, 
                                    width: 120
                                })
                            }
                        })
                    }
                }
            }
        }
        return {
            data: response.payload.data,
            meta: response.payload.meta,
            headers: utils.columns(newArray.length > 0 ? newArray :columnsArray)
        };
    })
    .then(res => (Object.assign({
        headers: res.headers,
        result: (res.data.dataList || []).map(d => {
            return Object.assign({}, d, {
                height: (d.fileMaxRow != null ? d.fileMaxRow * 30 : 30)
            })
        }),
        selects: (res.data.dataList || []).map((d,i) => ({
            value: d.resultId,
            checked: false,
            height: (d.fileMaxRow != null ? d.fileMaxRow * 30 : 30)
        })),
        checked: false,
        meta: res.meta,
        total: res.data.total,
        pageIndex: res.data.pageNum,
        pageSize: res.data.pageSize,
        notify: (res.data.dataList || []).length ? '' : '暂无数据...'
    })));
}

/**
 * @method querySearchById
 * @param {number} id
 * @return {promise}
 */
const querySearchById = (id) => {
    return fetch.get('zgcp/targetResult/get/'+ id, {})
    .then(response => {
        return response;
    });
}


export default {
    setRefresh,
    onSelect,
    getSelection,
    headers,
    querySearch,
    querySearchById,
}